import apiClient from "./client";

// fetch list of ZoneDto
export function getAll() {
  return apiClient.get("/inspections").then((res) => res.data);
}

export function getInspectionByStatus(statusId) {
  return apiClient
    .get(`/inspections/status/${encodeURIComponent(statusId)}`)
    .then((res) => res.data);
}

export function getById(id) {
  return apiClient.get(`/inspections/${encodeURIComponent(id)}`).then((res) => res.data);
}

export function deleteItem(id) {
  return apiClient.delete(`/inspections/${encodeURIComponent(id)}`);
}

export function createInspection(data) {
  return apiClient.post("/inspections", data).then((res) => res.data);
}

export function repeatInspection(id, data) {
  return apiClient.post(`/inspections/${encodeURIComponent(id)}/repeat`, data).then((res) => res.data);
}

export function updateInspection(id, data) {
  return apiClient.put(`/inspections/${encodeURIComponent(id)}`, data).then((res) => res.data);
}

export function startInspection(id, latitude, longitude) {
  return apiClient.post(`/inspections/${encodeURIComponent(id)}/start`, {
    latitude,
    longitude
  }).then((res) => res.data);
}

export function stopInspection(id, latitude, longitude) {
  return apiClient.post(`/inspections/${encodeURIComponent(id)}/stop`, {
    latitude,
    longitude
  }).then((res) => res.data);
}

export function getDueSoon(daysAhead = 7) {
  return apiClient.get(`/inspections/due-soon?daysAhead=${daysAhead}`).then((res) => res.data);
}

export function exportInspectionsToExcel() {
  return apiClient.post("/inspections/export/excel", {}, { responseType: 'blob' });
}
